import React from 'react'

import PartnerBonusAccrualView from 'pages/parts/PartnerBonusAccrualView'

function Index() {
	return (
		<PartnerBonusAccrualView
			accrualApiPath="/admin/partner-bonus/accrual"
			partnersHelperPath="/admin/helper/partners"
		/>
	)
}

export default Index
